import { getUrlDefaults } from '~/src/Lib/Nav'

export default getUrlDefaults('cultivars')
